/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://fbwtsh2uoreinbl77kegg3ck6i.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-kwuw2cqhffhsxpb4qhmz5lx2n4",
    "aws_cognito_identity_pool_id": "us-east-1:cc30dbdb-67b1-4d2f-9162-b5a4bd361caa",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_4w502iYJ1",
    "aws_user_pools_web_client_id": "14pp9lmr246mfgmitt5fjr67q",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "dinner-planner-images112034-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
